/*
 *
 * @desc: 数据校验 （https://www.npmjs.com/package/validator）
 * @author: haifn
 * @time: 2021-09-24
 */

/*
 * @function
 * @description 数据校验，依赖按需引入，目前只引入邮箱校验
 * @param {String} type 校验数据的类型
 * @param {String} val 校验数据的值
 * @param {Object} extra 额外参数
 *                 extra.allCountry 所有国家地区列表
 * @author haifn
 * @time: 2021-11-8 5:51:37
 *
 */
function validator({ type, val, extra = {} }) {
  switch (type) {
    case 'email':
      // 暂时不对长度做限制
      return /^[\w.-]+@[a-zA-Z\d-]+(\.[a-zA-Z\d-]+)*\.[a-zA-Z]{2,}$/.test(val);
    case 'invoiceTitle':
      // 发票抬头：发票抬头仅允许：汉字、字母、数字、-、（）、空格
      return /^[a-zA-Z0-9（）\s\-\u4E00-\u9FA5]+$/.test(val);
    case 'taxNumber':
      // 税号：大写字母+数字，或纯大写字母，或纯数字
      return /^[0-9A-Z]*$/g.test(val);
    case 'companyBankAccount':
      // 税号：数字
      return /^[0-9]*$/g.test(val);
    case 'phoneCode':
      // 长度大于6 || phoneCode不在我们自己库中的均为不合法
      if (!val || val.length > 6) return false;
      return extra.allCountry.some((e) => {
        return e.phoneCode === `${val}`;
      });
    case 'password':
      return val.trim().length >= 8;
    case 'zipCode':
      if (!val || typeof val !== 'string') return false;

      if (extra.CountryCode === 'US') {
        const zipCodeRule1 = new RegExp(/\d{5}/);
        const zipCodeRule2 = new RegExp(/\d{5}-\d{4}/);
        // 美国地区两种数据格式
        // eg1: XXXXX  (5个数字) e.g 10008
        // eg2: XXXXX-XXXX  (9数字加一个-) e.g 10008-9999
        if (zipCodeRule2.test(val)) return val.length === 10;
        if (zipCodeRule1.test(val)) return val.length === 5;
        return false;
      }

      if (extra.CountryCode === 'JP') {
        // 日本地区格式xxx-xxxx
        const zipCodeRuleJP = new RegExp(/\d{3}-\d{4}/);
        if (zipCodeRuleJP.test(val)) return val.length === 8;
        return false;
      }

      return val.length <= 11;
    case 'storeLinkUrl':
      if (!val) return false;
      if (val.indexOf('/') === 0) return true;
      return /\/\/store(|-dev|-test|-sit).insta360.com/gi.test(val);
    default:
      return false;
  }
}

export default validator;
